import { mainColor, UNIT } from '../../constants/theme';

export const styles = () => ({
  root: {
    width: '100%',
    borderTop: `0.1px solid ${mainColor.colorAdditional}`
  },
  paperStyle: {
    boxShadow: `1px 3px 5px #ccc`
  },
  boldText: {
    fontSize: UNIT,
    fontWeight: 'bolder'
  },
  headerFee: {
    fontWeight: 'normal',
    fontSize: UNIT * 0.6875,
    color: mainColor.colorBlack
  }
});
